/* RESPONSIBLE TEAM: team-channels */
import StepSerializer from '../step';

export default StepSerializer;
